import BaseIvrNode, { EMPTY_ERROR_ID_MESSAGE } from './baseIvrNode';
import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export default class VoiceAutomationNode extends BaseIvrNode {
  @IsString()
  @IsNotEmpty({ message: 'Please select the exit node' })
  handoffNodeId: string;

  @IsOptional()
  closedNodeId: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;

  @IsOptional()
  contextData: ContextData;

  @IsBoolean()
  record: boolean;
}

class ContextData {
  @IsString()
  @IsOptional()
  routingRuleKeyword: string;
}
